module.exports = __webpack_public_path__ + "media/images/icons/widgets-c2c2bf77d399641dba9265ed29c02d99.svg";